/* eslint-disable indent */
import { useContext, useEffect } from 'react';

import { sendAnalyticEvent } from '@src/components/web-analytic/utils';
import { analyticEvents } from '@src/constants';
import { Store } from '@src/store';

export const useAnalyticsNs = () => {
  const {
    state: {
      stateWizard: { wantNextStep, currentStep },
    },
  } = useContext(Store);

  useEffect(() => {
    if (wantNextStep) {
      switch (currentStep) {
        case 1:
          sendAnalyticEvent(analyticEvents.toStep2Accident);
          break;
        case 2:
          sendAnalyticEvent(analyticEvents.toStep3Accident);
          break;
        case 3:
          sendAnalyticEvent(analyticEvents.toStep4Accident);
          break;
        case 4:
          sendAnalyticEvent(analyticEvents.toStep5Accident);
          break;
        case 5:
          sendAnalyticEvent(analyticEvents.toStep7Accident);
          break;
        default:
          break;
      }
    }
  }, [wantNextStep]);
};
